import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BlogLayout"] */ "/opt/build/repo/src/components/blog/BlogLayout.tsx");
